"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AWSError = AWSError;
exports.AuthError = AuthError;
exports.DebtorCCError = DebtorCCError;
exports.DocassembleError = DocassembleError;
exports.DocketAlarmError = DocketAlarmError;
exports.DocumentError = DocumentError;
exports.FilesError = FilesError;
exports.MeridianLinkError = MeridianLinkError;
exports.ParameterError = ParameterError;
exports.PermissionsError = PermissionsError;
exports.SegmentError = SegmentError;
exports.TwilioError = TwilioError;
exports.ValidationError = ValidationError;

function AWSError() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.type = 'aws';
  this.code = error.code;
  this.message = error.message;
  this.data = error.data;
  this.stack = new Error().stack;
}

function AuthError() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.type = 'auth';
  this.code = error.code;
  this.status = error.status;
  this.message = error.message || 'Forbidden';
  this.data = error.data;
  this.stack = new Error().stack;
}

function DebtorCCError() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.type = 'debtorcc';
  this.code = error.code;
  this.message = error.message;
  this.data = error.data;
  this.stack = new Error().stack;
}

function DocassembleError() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.type = 'docassemble';
  this.code = error.code;
  this.message = error && error.message ? error.message : 'Error with Docassemble API';
  this.data = error.data;
  this.stack = new Error().stack;
}

function DocketAlarmError() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.type = 'docketAlarm';
  this.code = error.code;
  this.message = error && error.message ? error.message : 'Error with Docket Alarm API';
  this.data = error.data;
  this.stack = new Error().stack;
}

function DocumentError() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.type = 'document';
  this.code = error.code;
  this.message = error && error.message ? error.message : 'Error with Document Compilation';
  this.data = error.data;
  this.stack = new Error().stack;
}

function FilesError() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.type = 'file';
  this.code = error.code;
  this.message = error.message;
  this.data = error.data;
  this.stack = new Error().stack;
}

function MeridianLinkError() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.type = 'meridianLink';
  this.code = error.code;
  this.message = error && error.message ? error.message : 'Error with MeridianLink API';
  this.data = error.data;
  this.stack = new Error().stack;
}

function ParameterError() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.type = 'parameter';
  this.code = error.code;
  this.message = error.message;
  this.data = error.data;
  this.stack = new Error().stack;
}

function PermissionsError() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.type = 'permission';
  this.code = error.code;
  this.message = error.message;
  this.data = error.data;
  this.stack = new Error().stack;
}

function SegmentError() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.type = 'segment';
  this.code = error.code;
  this.message = error.message;
  this.data = error.data;
  this.stack = new Error().stack;
}

function TwilioError() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.type = 'twilio';
  this.code = error.code;
  this.message = error.message;
  this.data = error.data;
  this.stack = new Error().stack;
}

function ValidationError() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.type = 'validation';
  this.code = error.code;
  this.message = error.message;
  this.data = error.data;
  this.stack = new Error().stack;
}